import { action, observable } from 'mobx';
import { isBoolean } from '~/common/utils/typeCheckers.js';

export default class FatalErrorClass {
    @observable fatalError = false;

    @action setFatalError(bool) {
        this.fatalError = isBoolean(bool, this.fatalError);
    }
}
